import React from 'react';
import AuditCardItem from './AuditCardItem';
import Selectors from '../hooks/selectors';

const AuditCardItems = ({ category, code, items }) => {
  const state = Selectors.useAuditCardItems();
  return (
    items.map((item, index) => (
      <AuditCardItem
        allowCohortLink={state.allowCohortLink}
        allowCollectionLink={state.allowCollectionLink}
        allowDatasetLink={state.allowDatasetLink}
        allowRoleLink={state.allowRoleLink}
        allowSearchLink={state.allowSearchLink}
        allowRequestLink={state.allowRequestLink}
        allowUserLink={state.allowUserLink}
        allowUserGroupLink={state.allowUserGroupLink}
        audit={item}
        category={category}
        key={`audits_list_item_${item.code}`}
        upward={index > 4}
        withMeta={item.primary_name && !code}
      />
    ))
  );
};

export default AuditCardItems;
